import { EntityId } from "@bbwt/interfaces";
import { PagedCrudService } from "@features/grid";

export abstract class PagedParentCrudService<TEntity> extends PagedCrudService<TEntity> {
    abstract urlTempl: string;
    public url: string;

    setParentId(parentId: EntityId) {
        if (this.urlTempl && parentId) {
            this.url = this.urlTempl.replace("{parentId}", parentId.toString());
        }
    }
}
